import { createFileRoute, redirect } from '@tanstack/react-router'

// Bare `/dev-resources` has no content of its own — redirect to the first tab (email templates).
export const Route = createFileRoute('/_app/dev-resources/')({
  beforeLoad: () => {
    throw redirect({ to: '/dev-resources/emails' })
  },
})
